import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const allowLocalBypass = (import.meta.env.VITE_MONITOR_ALLOW_LOCAL_BYPASS ?? 'false') === 'true';

export const shouldBypassAuth = () => {
  if (!allowLocalBypass) {
    return false;
  }
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
};

const bypassAuth = shouldBypassAuth();

const ensureConfig = () => {
  const requiredKeys: Array<keyof typeof firebaseConfig> = [
    'apiKey',
    'authDomain',
    'projectId',
    'storageBucket',
    'messagingSenderId',
    'appId',
  ];
  const missing = requiredKeys.filter((key) => !firebaseConfig[key]);

  if (missing.length) {
    throw new Error(`Firebase config incompleta: faltam ${missing.join(', ')}`);
  }
};

if (!bypassAuth) {
  ensureConfig();
}

const app = bypassAuth ? null : getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = app ? getAuth(app) : null;
export const firestore = app ? getFirestore(app) : null;

